import PaintFormulasWorkspace from '../../placeholders/PaintFormulasWorkspace';

export default PaintFormulasWorkspace;
